export default __webpack_public_path__ + "amerikan-futbol.png";